import { EditTableThemeSizeConfig } from './types';

const large: EditTableThemeSizeConfig = {
  EditTable: {},
};

export default large;
